import { useCallback, useState } from 'react'

const MODE_KEY = 'pingdesk.theme'

function readStoredMode() {
  try {
    const saved = localStorage.getItem(MODE_KEY)
    return saved === 'dark' || saved === 'light' ? saved : null
  } catch {
    // Private browsing / blocked storage — fall back to the caller's default.
    return null
  }
}

/**
 * Light/dark mode for the MUI ThemeProvider. A stored choice beats `initial`.
 */
export function useColorMode(initial = 'light') {
  const [mode, setMode] = useState(() => readStoredMode() ?? initial)

  const toggleMode = useCallback(() => {
    setMode((current) => {
      const next = current === 'dark' ? 'light' : 'dark'
      try {
        localStorage.setItem(MODE_KEY, next)
      } catch {
        // Non-fatal: the toggle still applies for this session.
      }
      return next
    })
  }, [])

  return [mode, toggleMode]
}
